// components/WorkflowGuide.jsx
import React, { useEffect, useState } from "react";
import Joyride, { STATUS } from "react-joyride";
import { useLocation } from "react-router-dom";

export default function WorkflowGuide() {
   const location = useLocation();
  const [run, setRun] = useState(false);
  const [steps, setSteps] = useState([]);

  useEffect(() => {
    const shouldRun =
      location.search.includes("guide=true") ||
      location.state?.fromWorkflowListGuide;

    if (!shouldRun) return;

    if (location.search.includes("guide=true")) {
      window.history.replaceState({}, "", location.pathname);
    }

    const baseSteps = [
      {
        target: "body",
        content: (
          <div className="text-center">
            <h6 className="fw-bold mb-3 text-primary-600">
              Welcome to Workflows!
            </h6>
            <p className="mb-0 text-neutral-600 text-sm">
              This is the master control panel for all Workflows — the complete
              step-by-step process your team follows from the moment a vehicle
              arrives until it leaves.
            </p>
          </div>
        ),
        placement: "center",
        disableBeacon: true,
      },

      {
        target: "body",
        content: (
          <div className="text-center">
            <h6 className="fw-bold mb-3 text-primary-600">
              Assign Staff — It’s Mandatory!
            </h6>
            <p className="mb-0 text-neutral-600 text-sm">
              Assign staff to workflow steps to ensure each task is handled by
              the right person.
            </p>
          </div>
        ),
        placement: "center",
        disableBeacon: true,
      },
      {
        target: "body",
        content: (
          <div>
            <h4 className="fw-bold d-flex align-items-center gap-2 mb-3 text-primary-600">
              Click Here!
            </h4>
            <p className="mb-3 text-neutral-700">
              This button opens the <strong>Workflow Editor</strong>
            </p>
            <p className="fw-bold text-lg text-brand">
              For each step,{" "}
              <span className="text-danger-600">
                assigning staff is mandatory!
              </span>
            </p>
          </div>
        ),
        placement: "center",
        disableBeacon: true,
      },
    ];

    const startTour = () => {
      const editBtn = document.querySelector(".workflow-edit-btn");

      if (editBtn) {
        editBtn.classList.add("joyride-highlight-btn");

        const finalSteps = [...baseSteps];
        setSteps(finalSteps);
      } else {
        setSteps(baseSteps);
      }
      setRun(true);
    };

    const timer = setTimeout(startTour, 1000);

    return () => {
      clearTimeout(timer);
      document.querySelectorAll(".joyride-highlight-btn").forEach((el) => {
        el.classList.remove("joyride-highlight-btn");
      });
    };
  }, []);

  const handleJoyrideCallback = (data) => {
    const { status, action, index } = data;

    if (
      [STATUS.FINISHED, STATUS.SKIPPED].includes(status) ||
      action === "close"
    ) {
      document.querySelectorAll(".joyride-highlight-btn").forEach((el) => {
        el.classList.remove("joyride-highlight-btn");
      });
      setRun(false);
    }

    if (index === 3 && data.type === "step:before") {
      document.querySelector(".workflow-edit-btn")?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  if (!run) return null;

  return (
    <>
      <Joyride
        steps={steps}
        run={run}
        continuous={true}
        showProgress={true}
        showSkipButton={true}
        scrollToFirstStep={true}
        callback={handleJoyrideCallback}
        styles={{
          options: {
            zIndex: 99999,
            primaryColor: "var(--brand)",
            backgroundColor: "var(--white)",
            textColor: "var(--neutral-800)",
            arrowColor: "var(--white)",
            overlayColor: "rgba(27, 36, 49, 0.92)",
          },
          buttonNext: {
            backgroundColor: "var(--brand)",
            color: "white",
            borderRadius: "var(--rounded-16)",
            padding: "12px 32px",
            fontWeight: "600",
          },
          tooltip: {
            borderRadius: "var(--rounded-20)",
            padding: "32px",
            maxWidth: "460px",
            boxShadow: "var(--shadow-4)",
            backgroundColor: "var(--white)",
          },
        }}
        locale={{ back: "Back", next: "Next", last: "Done", skip: "Skip" }}
      />

      <style jsx>{`
        @keyframes glowPulse {
          0%,
          100% {
            box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.7);
          }
          50% {
            box-shadow: 0 0 0 20px rgba(59, 130, 246, 0);
          }
        }

        .workflow-edit-btn.joyride-highlight-btn {
          position: relative !important;
          z-index: 999999 !important;
          animation: glowPulse 2s infinite ease-in-out !important;
          border: 4px solid var(--brand) !important;
          border-radius: 50% !important;
          transform: scale(1.15) !important;
        }

        .workflow-edit-btn.joyride-highlight-btn::after {
          content: "Click Here";
          position: absolute;
          top: -50px;
          left: 50%;
          transform: translateX(-50%);
          background: var(--brand);
          color: white;
          padding: 8px 18px;
          border-radius: 30px;
          font-size: 14px;
          font-weight: bold;
          white-space: nowrap;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
        }

        .workflow-edit-btn.joyride-highlight-btn::before {
          content: "";
          position: absolute;
          top: -16px;
          left: 50%;
          transform: translateX(-50%);
          border: 12px solid transparent;
          border-top-color: var(--brand);
        }
      `}</style>
    </>
  );
}